import React from "react";
import { Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { colors } from "@ippon/shared-components";

interface LabelHelpTooltipProps {
  /** ツールチップに表示する説明文 */
  title: React.ReactNode;
  /** アイコンサイズ (px) */
  size?: number;
}

/**
 * フォームラベルの右に置く「?」ヘルプアイコン。
 * ホバー / タップでツールチップに補足説明を表示する。
 * CustomSingleSelect 等の labelSuffix に渡して使う。
 */
export const LabelHelpTooltip: React.FC<LabelHelpTooltipProps> = ({
  title,
  size = 15,
}) => {
  return (
    <Tooltip title={title} arrow placement="top" enterTouchDelay={0}>
      <HelpOutlineIcon
        sx={{
          ml: "4px",
          fontSize: size,
          color: colors.text.secondary,
          transition: "color 0.15s ease",
          "&:hover": { color: colors.primary.main },
        }}
      />
    </Tooltip>
  );
};

export default LabelHelpTooltip;
